export default __webpack_public_path__ + "static/media/GS_instruction_icon.2727895d.svg";